import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { MdKeyboardBackspace } from "react-icons/md"
import { CandidateInterviewHistory } from "../../../Redux/action/CandidateInterviewHistory";
import TableHeader from "../../Common/TableHeader";
// import AddRating from "./AddRating";

const JobsInterviewHistory = () => {
    // var today = new Date();
    // var dd = String(today.getDate()).padStart(2, "0");
    // var mm = String(today.getMonth() + 1).padStart(2, "0");
    // var yyyy = today.getFullYear();
    // today = yyyy + "-" + mm + "-" + dd;
    const { userResult } = useSelector((state) => state.Auth);
    const candidateId = userResult?.userid;;
    const userInfo = useSelector((state) => state.CandidateJobHistory.result);

    let dispatch = useDispatch();

    useEffect(() => {
        dispatch(CandidateInterviewHistory(candidateId));
    }, []);

    return (
        <div>
            <div
                className=""
            >
                <TableHeader heading={'Interview History'} />
                <div className="">
                    <div className="C-History-table-responsive">
                        <table className="table-data">
                            <thead>
                                <tr>
                                    <th scope="col">Interview Id</th>
                                    <th scope="col">Candidate Details</th>
                                    <th scope="col">Designation</th>
                                    <th scope="col">Interview Date</th>
                                    <th scope="col">Score</th>
                                    <th scope="col">Candidate Status</th>
                                    <th scope="col">Interviewer Status</th>
                                    <th scope="col">Hiring Status</th>
                                </tr>
                            </thead>
                            <tbody>
                                {userInfo &&
                                    userInfo.map((item, i) => {
                                        return (
                                            <>
                                                <tr key={i}>
                                                    <td>#{item.interviewId}</td>
                                                    <td>{item.candidateName}</td>
                                                    <td>{item.jobPosition}</td>
                                                    <td>{item.interviewDate}</td>
                                                    <td>{item.rating}</td>
                                                    <td>{item.isAcceptedByCandidate}</td>
                                                    <td>{item.isAcceptedByInterviewer}</td>

                                                    {/* {item.isAcceptedByCandidate === true ? (
                                                        <td style={{ background: "green", color: "white" }}>
                                                            Accepted
                                                        </td>
                                                    ) : (
                                                        <td style={{ background: "red", color: "white" }}>
                                                            Pending...
                                                        </td>
                                                    )} */}
                                                    {/* {item.isAcceptedByInterviewer === true ? (
                                                        <td style={{ background: "green", color: "white" }}>
                                                            Accepted
                                                        </td>
                                                    ) : (
                                                        <td style={{ background: "red", color: "white" }}>
                                                            Pending...
                                                        </td>
                                                    )} */}

                                                    <td>{item.candidateInterviewStatus}</td>
                                                    {/* <Link to={`/apply-job-list/${item.jobId}`}><td>View</td></Link>   */}
                                                </tr>
                                            </>
                                        );
                                    })}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default JobsInterviewHistory;
